<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Close2`]" width="1em" height="1em" v-bind="$attrs"><path d="M15.5353 8.46452C15.9259 8.85505 15.9259 9.48821 15.5353 9.87874L13.4143 11.9998L15.5358 14.1214C15.9264 14.5119 15.9264 15.1451 15.5358 15.5356C15.1453 15.9261 14.5121 15.9261 14.1216 15.5356L12.0001 13.414L9.87849 15.5356C9.48797 15.9261 8.8548 15.9261 8.46428 15.5356C8.07376 15.1451 8.07376 14.5119 8.46428 14.1214L10.5858 11.9998L8.46477 9.87874C8.07424 9.48821 8.07424 8.85505 8.46477 8.46452C8.85529 8.074 9.48846 8.074 9.87898 8.46452L12.0001 10.5856L14.1211 8.46452C14.5117 8.074 15.1448 8.074 15.5353 8.46452Z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02943 3 3 7.02943 3 12C3 16.9706 7.02943 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02943 16.9706 3 12 3Z"/></svg>
</template>
<script>

export default {
  name: 'IconClose2',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
